import { render, staticRenderFns } from "./editScoreDialog.vue?vue&type=template&id=43a42b7e&scoped=true&"
import script from "./editScoreDialog.vue?vue&type=script&lang=js&"
export * from "./editScoreDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a42b7e",
  null
  
)

export default component.exports